import * as S from './style';
import { faEye } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
const ProjectCard = ({ project: { img, name, link, categories }, catActive }) => {
  return (
    <S.WrapperCard
      bg={`/images/${img}`}
      className={`animate__animated ${
        categories.includes(catActive) || catActive === 'All'
          ? 'animate__zoomIn'
          : 'animate__zoomOut'
      }`}>
      <S.WrapperCard_Hover>
        <S.Head_5>{name}</S.Head_5>
        <S.Link href={`${link}`} target="_blank" rel="noopener noreferrer">
          <FontAwesomeIcon icon={faEye} />
        </S.Link>
      </S.WrapperCard_Hover>
    </S.WrapperCard>
  );
};

export default ProjectCard;
